import {CanActivateChildFn, CanActivateFn, Router, UrlTree} from "@angular/router";
import {inject} from "@angular/core";
import {of, switchMap} from "rxjs";
import {AuthService} from "../auth.service";

export const AuthGuard: CanActivateFn | CanActivateChildFn = () => {
  const router: Router = inject(Router);

  // Check the authentication status
  return inject(AuthService).check().pipe(
    switchMap((authenticated) => {
      // If the user is not authenticated...
      if (!authenticated) {
        // Redirect to the sign-in page
        const urlTree: UrlTree = router.parseUrl(`/auth/sign-in`);
        return of(urlTree);
      }
      // Allow the access
      return of(true);
    }),
  );
};
